/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailBankBulkSendInvoicesRequest
 */
export interface MailBankBulkSendInvoicesRequest {
    /**
     * 
     * @type {string}
     * @memberof MailBankBulkSendInvoicesRequest
     */
    invoiceIds?: string;
}

/**
 * Check if a given object implements the MailBankBulkSendInvoicesRequest interface.
 */
export function instanceOfMailBankBulkSendInvoicesRequest(value: object): value is MailBankBulkSendInvoicesRequest {
    return true;
}

export function MailBankBulkSendInvoicesRequestFromJSON(json: any): MailBankBulkSendInvoicesRequest {
    return MailBankBulkSendInvoicesRequestFromJSONTyped(json, false);
}

export function MailBankBulkSendInvoicesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailBankBulkSendInvoicesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceIds': json['invoiceIds'] == null ? undefined : json['invoiceIds'],
    };
}

export function MailBankBulkSendInvoicesRequestToJSON(json: any): MailBankBulkSendInvoicesRequest {
    return MailBankBulkSendInvoicesRequestToJSONTyped(json, false);
}

export function MailBankBulkSendInvoicesRequestToJSONTyped(value?: MailBankBulkSendInvoicesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceIds': value['invoiceIds'],
    };
}

